import {
  init_fogFragment
} from "./chunk-5PR2DJJF.mjs";
import {
  init_clipPlaneFragment
} from "./chunk-S7OWH5R2.mjs";
import {
  init_clipPlaneFragmentDeclaration
} from "./chunk-4NV4RXHT.mjs";
import {
  init_fogFragmentDeclaration
} from "./chunk-PTZ7MAEV.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/color.fragment.js
var name, shader, colorPixelShaderWGSL;
var init_color_fragment = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/color.fragment.js"() {
    init_shaderStore();
    init_clipPlaneFragmentDeclaration();
    init_fogFragmentDeclaration();
    init_clipPlaneFragment();
    init_fogFragment();
    name = "colorPixelShader";
    shader = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
#define VERTEXCOLOR
varying vColor: vec4f;
#else
uniform color: vec4f;
#endif
#include<clipPlaneFragmentDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
fragmentOutputs.color=input.vColor;
#else
fragmentOutputs.color=uniforms.color;
#endif
#include<fogFragment>(color,fragmentOutputs.color)
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    colorPixelShaderWGSL = { name, shader };
  }
});

export {
  colorPixelShaderWGSL,
  init_color_fragment
};
